import {
    COLETA_MODO_TELA,
    COLETA_SET_AGUARDANDO,
    COLETA_LISTADO,
    COLETA_OPCOES_CARREGADAS,
    COLETA_AREAS_CARREGADAS,
    COLETA_HISTORICO_CARREGADO
} from './coletaActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    clientes: [],
    consultores: [],
    usuariosColeta: [],
    status: [],
    formasPagamento: [],
    historico: [],
    areasCliente: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case COLETA_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case COLETA_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case COLETA_LISTADO:
            return {
                ...state,
                lista: action.payload.data || []
            };

        case COLETA_OPCOES_CARREGADAS:
            return {
                ...state,
                clientes:
                    action.payload.data.clientes || [],
                consultores:
                    action.payload.data.consultores || [],
                usuariosColeta:
                    action.payload.data.usuarios_coleta || [],
                status:
                    action.payload.data.status || [],
                formasPagamento:
                    action.payload.data.formas_pagamento || []
            };

        case COLETA_AREAS_CARREGADAS:
            return {
                ...state,
                areasCliente: action.payload.data || []
            };

        case COLETA_HISTORICO_CARREGADO:
            return {
                ...state,
                historico: action.payload.data || []
            };

        default:
            return state;
    }
};
